import React from 'react';
import ReactDOM from 'react-dom';
import 'tachyons';
import './index.css';

import App from "./containers/App"


ReactDOM.render(<App/>,
  document.getElementById('root')
);
